import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { finalize } from 'rxjs';


import { FilledInputDirective } from '@shared/directives/filledInput.directive';
import { IUserProfile } from '@app/features/profile/interfaces/profile.interface';
import { UserService } from '@app/features/profile/services/user.service';
import { AuthService } from '@app/features/auth/services/auth.service';
import { Spinner } from '@shared/components/spinner/spinner';
import { Utility } from '@common/utility';

@Component({
  selector: 'app-login',
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, FilledInputDirective, Spinner, NgOptimizedImage],
  providers: [AuthService, Utility],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {
  loginForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  loader = signal(false);
  buttonText = '02:00';
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private fb: FormBuilder,
    public utility: Utility,
    private router: Router,
  ) {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
  onSubmit(): void {
    this.loader.set(true)
    this.authService.userLogin(this.loginForm.value).pipe(
      finalize(() => {
        this.loader.set(false);
      })
    ).subscribe({
      next: (res) => {
        if (res?.success) {
          this.handleSuccessfulLogin(res)
        }
      },
      error: (err) => {
        this.mapErrors(err?.error?.errors);
      },
    })
  }
  handleSuccessfulLogin(res: any): void {
    this.storeAuthData(res.data);
    const invitedUserData = this.getInvitedUserData();
    if (invitedUserData?.data?.is_existing_user) {
      this.handleInvitedUser(invitedUserData, res.data.user.is_workspace_created);
    } else {
      this.navigateToWorkspace(res.data.user.is_workspace_created);
    }
    this.loadUserProfile();
  }
  storeAuthData(data: any): void {
    localStorage.setItem('authToken', data.token);
    localStorage.setItem('is_workspace_created', data.user.is_workspace_created ? 'true' : 'false');
  }

  getInvitedUserData(): any {
    try {
      const rawData = localStorage.getItem('invited_user_data');
      return rawData ? JSON.parse(rawData) : null;
    } catch (error) {
      return null;
    }
  }
  handleInvitedUser(invitedUserData: any, isWorkspaceCreated: boolean): void {
    this.authService.acceptInvitaion(invitedUserData.token).subscribe({
      next: (resp) => {
        if (resp.success) {
          this.navigateToWorkspace(isWorkspaceCreated);
        }
      },
      error: (error) => {
        // Fallback navigation even if invitation acceptance fails
        this.navigateToWorkspace(isWorkspaceCreated);
      }
    });
  }
  navigateToWorkspace(isWorkspaceCreated: boolean): void {
    const route = isWorkspaceCreated ? '/workspace/choose' : '/workspace/create';
    this.router.navigate([route]);
  }

  loadUserProfile(): void {
    this.userService.getUserProfile().subscribe({
      next: (profileRes: { success: boolean; data: IUserProfile }) => {
        if (profileRes.success) {
          this.userService.setUserDetail(profileRes.data);
        }
      },

    });
  }
  mapErrors(json: any) {
    if (json?.email) {
      this.loginForm.get('email')?.setErrors({ serverError: json.email[0] });
    }
    if (json?.password) {
      this.loginForm.get('password')?.setErrors({ serverError: json.password[0] })
    }
  }
}
